import React, { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function TiltCard({ children, className, onClick, style, ...props }) {
  const ref = useRef(null);

  // Mouse coordinates mapped to 0..1 range
  const x = useMotionValue(0.5);
  const y = useMotionValue(0.5);

  // Spring configuration for buttery smooth movements
  const springConfig = { damping: 25, stiffness: 220, mass: 0.5 };
  
  // Map x/y to rotX/rotY values (tilt ranges between -12 and 12 degrees)
  const rotateX = useSpring(useTransform(y, [0, 1], [12, -12]), springConfig);
  const rotateY = useSpring(useTransform(x, [0, 1], [-12, 12]), springConfig);

  const handleMouseMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;
    
    // Relative coordinates
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;

    x.set(mouseX / width);
    y.set(mouseY / height);
  };

  const handleMouseLeave = () => {
    x.set(0.5);
    y.set(0.5);
  };

  // Radial glow gradient that moves with the cursor
  const glowBg = useTransform(
    [x, y],
    ([latestX, latestY]) =>
      `radial-gradient(circle 120px at ${latestX * 100}% ${latestY * 100}%, rgba(217, 79, 0, 0.15), transparent 80%)`
  );

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{
        rotateX,
        rotateY,
        transformStyle: "preserve-3d",
        transformPerspective: 800,
        ...style,
      }}
      className={className}
      onClick={onClick}
      {...props}
    >
      {/* Dynamic Hover Glow Overlay */}
      <motion.div
        className="tilt-glow"
        style={{
          position: "absolute",
          inset: 0,
          background: glowBg,
          pointerEvents: "none",
          zIndex: 2,
          borderRadius: "inherit",
        }}
      />
      {/* 3D Depth Wrapper */}
      <div 
        style={{ 
          transform: "translateZ(24px)", 
          transformStyle: "preserve-3d", 
          height: "100%", 
          width: "100%",
          display: "flex", 
          flexDirection: "column",
          position: "relative"
        }}
      >
        {children}
      </div>
    </motion.div>
  );
}
